import Reducers from "types/Reducers";
// Model
import { RootState } from "store";

export const selectSnackbarMessage = (state:RootState) => state[Reducers.UI].snackbarMessage;